module.exports = __webpack_public_path__ + "img/pasture_natural_low.54fc10fa.webp";